import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormArray, FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  EditorBookingItemBulkName,
  EditorBookingItemBulkNameEditStore
} from '../editor-booking-item-bulk-name-edit/editor-booking-item-bulk-name-edit.store';
import { EditorBookingItemTreeStore } from '../editor-booking-item-tree/editor-booking-item-tree.store';
import { getLevelLinesListFromItemList } from '../utils';


@Component({
    selector: 'eas-editor-booking-item-bulk-name-edit',
    templateUrl: './editor-booking-item-bulk-name-edit.component.html',
    styleUrls: ['./editor-booking-item-bulk-name-edit.component.css'],
    standalone: false
})
export class EditorBookingItemBulkNameEditComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  replacingBulkNameList: EditorBookingItemBulkName[];
  levelLinesList: boolean[][];
  replacingNameListForm: FormArray;

  namesReplaced: number;

  constructor(
    private dialogRef: MatDialogRef<EditorBookingItemBulkNameEditComponent>,
    private itemTreeStore: EditorBookingItemTreeStore,
    private itemBulkNameEditStore: EditorBookingItemBulkNameEditStore
  ) {

  }

  ngOnInit() {
    this.itemBulkNameEditStore.replacingNameListForm$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(replacingNameListForm => {
        this.replacingNameListForm = replacingNameListForm;
      });

    this.itemBulkNameEditStore.replacingBulkNameList$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(replacingBulkNameList => {
        this.replacingBulkNameList = replacingBulkNameList;
        this.levelLinesList = replacingBulkNameList === undefined
          ? undefined
          : getLevelLinesListFromItemList(replacingBulkNameList);
      });
  }

  ngOnDestroy() {
    this.itemBulkNameEditStore.terminate();
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onSearchAndReplace(sarchAndReplace: { search: string, replace: string }) {
    let namesReplaced = 0;
    this.replacingNameListForm.controls.forEach(replacingNameControl => {
      if (replacingNameControl.value.includes(sarchAndReplace.search)) {
        replacingNameControl.markAsDirty();
        replacingNameControl.setValue(replacingNameControl.value.replace(
          sarchAndReplace.search,
          sarchAndReplace.replace
        ));
        namesReplaced++;
      }
    });
    this.namesReplaced = namesReplaced;
  }

  onSubmit() {
    this.itemBulkNameEditStore.save();
    this.itemTreeStore.stopEditingNameList();
    this.dialogRef.close();
  }

  onCancel() {
    this.itemTreeStore.stopEditingNameList();
    this.dialogRef.close();
  }

  getFormControl(index): FormControl {
    return this.replacingNameListForm.at(index) as FormControl;
  }
}
